import { useConditionStore } from "../condition/conditions.store";
import { useEffectStore } from "../effect/effects.store";
import { getImageCopyData } from "../image/imageFunctions";
import { useImageStore } from "../image/images.store";
import { useRequirementStore } from "../requirement/requirements.store";
import type { ItemType } from "../ItemOfStore";
import type { ItemOfStore } from "../ItemOfStore";
import type { ActionItem } from "./ActionItem";

export function isMultiRoundAction(action: ActionItem) {
  const effects = useEffectStore().byAction[action.id] ?? [];
  return effects.some((effect) => effect.impulseExpressions.length > 1);
}

export function getActionEffectsDuration(actionId: number) {
  const effects = useEffectStore().byAction[actionId] ?? [];
  return effects.reduce((longestEffectOffset, effect) => {
    return Math.max(longestEffectOffset, effect.impulseExpressions.length);
  }, 0);
}

export function isAction(item: ItemOfStore<ItemType>): item is ActionItem {
  return item.type === "action";
}

export function getActionCopyData(action: ActionItem) {
  const data = [];

  // Add image
  if (action.imageId != null) {
    const imageStore = useImageStore();
    const image = imageStore.items[action.imageId];
    if (image != null) {
      data.push(...getImageCopyData(image));
    }
  }

  data.push(action);

  // add effects - effects should be copied AFTER the action,
  // so that the copied effects are linked to the copied action
  const effectStore = useEffectStore();
  const effects = effectStore.byAction[action.id] || [];
  for (const effect of effects) {
    data.push(effect);
  }

  // add requirements
  // requirements should be copied AFTER the action,
  // so that the copied requirements are linked to the copied action
  const requirementStore = useRequirementStore();
  const requirements = requirementStore.byItemUid[action.uid] || [];
  for (const requirement of requirements) {
    data.push(requirement);
  }

  // add conditions
  // conditions should be copied AFTER the requirements,
  // so that the copied conditions are linked to the copied requirements
  const conditionStore = useConditionStore();
  for (const requirement of requirements) {
    const conditions = conditionStore.getBySource(requirement);
    for (const condition of conditions) {
      data.push(condition);
    }
  }

  return data;
}
